import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IGames } from '../../services/games.service';
import Phaser from 'phaser';

// import your Phaser Editor generated config or scene
import { Game } from '../../../phaser/src/games/donut-fall/scenes/Game.js';
import { TitleScreen } from '../../../phaser/src/games/donut-fall/scenes/TitleScreen';
import { ModalController } from '@ionic/angular';
import { AccountService, IApiAccount, IRewardPointsCardRequest } from 'src/app/account/services/account.service';
import { SettingService } from '../../services/setting.service';


@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.scss'],
  standalone: false
})
export class GamesComponent  implements AfterViewInit, OnDestroy {

  @Input() games!: IGames;

  @ViewChild('gameContainer', { static: true })
  gameContainer!: ElementRef;

  game!: Phaser.Game;

  requestAddPoints: IRewardPointsCardRequest;
  primary: IApiAccount;

  constructor(
    private modalCtrl: ModalController,
    public settings: SettingService,
    private accountService: AccountService,
  ) { }

  ngOnInit() {
    console.log(this.games);
    this.getPrimary();
  }

  ngAfterViewInit(): void {

    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      title: 'Donut-Fall',
      parent: this.gameContainer.nativeElement, // IMPORTANT
      width: 800,
      height: 500,
      backgroundColor: '#441975',

      scene: [
        // TitleScreen,
        Game
      ],

      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH
      },

      physics: {
        default: 'arcade',
        arcade: {
          gravity: {
            x: 0,
            y: 0
          }
        }
      }
    };

    this.game = new Phaser.Game(config);

    // If your scene key is 'Game'
    // i'll push in some additional data from the games config here
    this.game.scene.start('Game', {
      //missing this config
      pointsRewardThreshold: [
        {
            requiredPoints: 500,
            reward: this.games.games[0].earnedPointsOnSuccess
        }
      ],

      onExit: () => {
        this.modalCtrl.dismiss();
      },
      
      givePoints: () => {
        this.earnPoints(this.games.games[0].earnedPointsOnSuccess).subscribe(async rewards => {
          console.log("points earned from game");
        });
      },


      earnedPointsOnSuccess: this.games.games[0].earnedPointsOnSuccess,
      rewardedPointsName: this.games.games[0].rewardedPointsName,

      attempts: this.games.games[0].attempts,
      userTimer: this.games.games[0].userTimer,
      startTime: this.games.games[0].timeAllowedInSeconds,

      limitedMoves: this.games.games[0].limitedMoves,
      numberOfMoves: this.games.games[0].numberOfMoves,

      minimumLengthForPoints: this.games.games[0].minimumLengthForPoints,
      minimumPointsGain: this.games.games[0].minimumPointsGain,
      pointsMutiplier: this.games.games[0].pointsMutiplier,
      bonusPointsMultiGroups: this.games.games[0].bonusPointsMultiGroups,

      gamebackgroundColor: this.games.games[0].gameBackgroundColor,

      cellWidth: this.games.games[0].cellWidth,
      cellHeight: this.games.games[0].cellHeight,

      cols: this.games.games[0].cols,
      rows: this.games.games[0].rows
    });
  }

  ngOnDestroy(): void {
    if (this.game) {
      this.game.destroy(true);
    }
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }

  earnPoints(points: number) {
    this.requestAddPoints = {
      externalProviderId: Number(this.settings.configuration.externalProviderId),
      cardNumber: this.primary.CardNumber,
      pointsAmount: points
    }

    return this.accountService.earnPoints(this.requestAddPoints);
  }

  async getPrimary() {

    this.accountService.getPrimary()
      .subscribe(
        (primary) => {
          this.primary = primary;
        });
  }
}
